<template>
  <div>
    <div v-if="mode === 'DESIGN'" >
<!--      表单设计时展示的mode-->
      <el-date-picker size="medium" disabled :type="type" :placeholder="placeholder"></el-date-picker>
    </div>
    <div v-else>
<!--      表单申请时展示的mode-->
      <el-date-picker v-if="!readerMode"
                      :disabled="isDisabled"
                      v-model="_value"
                      :format="format"
                      :value-format="format"
                      size="medium"
                      clearable
                      :type="type"
                      :placeholder="placeholder"
                      style="width: 100%;"
      ></el-date-picker>
      <div v-else v-text="value" style="width: 100%"></div>
    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'

export default {
  mixins: [componentMinxins],
  name: "DateTime",
  components: {},
  props:{
    value: {
      default: null
    },
    isDisabled:{
      type: Boolean,
      default: false,
    },
    format:{
      type: String,
      default: 'yyyy-MM-dd HH:mm:ss'
    },
    placeholder:{
      type: String,
      default: '请选择日期时间'
    },
    readerMode: {
      type: Boolean,
      default: false,
    },
  },
  computed:{
    type(){
      switch (this.format){
        case 'yyyy': return 'year';
        case 'yyyy-MM': return 'month';
        case 'yyyy-MM-dd': return 'date';
        case 'yyyy-MM-dd HH:mm:ss': return 'datetime';
        default: return 'datetime';
      }
    },
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style scoped>

</style>
